import { render, staticRenderFns } from "./NavProfile.vue?vue&type=template&id=36ee35cf&scoped=true&"
import script from "./NavProfile.vue?vue&type=script&lang=ts&"
export * from "./NavProfile.vue?vue&type=script&lang=ts&"
import style0 from "./NavProfile.vue?vue&type=style&index=0&id=36ee35cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ee35cf",
  null
  
)

export default component.exports